import styled, { css } from 'styled-components';

const borderColor = {
  red: '#F53832',
};

export const Container = styled.div`
  width: ${props => (props.hasStatus  ? '70%' : '320px')};
  height: 285px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000066;
  border-style: solid;
  border-width: ${({ color }) => (color ? '4px' : '0.5px')};
  border-color: ${({ color }) => (color ? borderColor[color] : '#707070')};
  border-radius: 16px;
  cursor: ${props => (props.hasChildren ? 'default' : 'pointer')};
  padding: ${props => (props.title === 'Marketing' ? '24px' : '30px')};
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 30px;
  margin-left: 15px;
  margin-right: 15px;

  @media (max-width: 1510px) {
    width: ${props => (props.hasStatus  ? '100%' : '380px')};
  }
  @media (max-width: 1330px) {
    width: ${props => (props.hasStatus  ? '100%' : '380px')};
  }
  @media (max-width: 1105px) {
    width: ${props => (props.hasStatus  ? '100%' : '300px')};
  }
  @media (max-width: 972px) {
    width: ${props => (props.hasStatus  ? '100%' : '250px')};
  }
  @media (max-width: 870px) {
    width: 100%;
    height: auto;
  }
  @media (min-width: 770px) {
    display: ${props => (props.title === 'Marketing' ? 'none' : 'flex')};
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${props => (props.hasChildren ? '5px' : 0)};
  justify-content: flex-start;

  ${({ ac }) =>
    ac &&
    css`
      justify-content: center;
      transform: translateY(15px);
    `}
`;

export const Title = styled.span`
  color: ${({ color }) => (color ? borderColor[color] : '#707070')};
  font-size: 18px;
  margin: ${props =>
    props.title === 'Status do pedido' ? '10px 0px 0px -5px' : '0'};
`;

export const Icon = styled.img`
  margin-right: 20px;
  height: auto;

  ${({ ac }) =>
    ac &&
    css`
      margin-right: -20px;
      transform: translateX(-150%);

      @media (max-width: 315px) {
        transform: translateX(-80%);
      }

      @media (min-width: 871px) and (max-width: 972px) {
        transform: translateX(-100%);
      }
    `}
`;

export const IconUIContainer = styled.div`
  margin-right: 20px;
  height: auto;
  color: #707070;
`;
